<template>
    <v-card class="round-card background-2 mt-4 pb-3" v-if="tickets.length > 0">
        <v-card-title class="pa-3 cursor-pointer" @click="expanded = !expanded">
            <v-icon color="warning" class="mr-2">mdi-ticket-outline</v-icon>
            <span class="subtitle-2">Altri Ticket Aperti ({{ tickets.length }})</span>
            <v-spacer></v-spacer>
            <v-icon>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-card-title>

        <v-expand-transition>
            <div v-show="expanded">
                <v-divider></v-divider>
                <v-list dense class="pa-0 background-2">
                    <v-list-item
                        v-for="ticket in tickets"
                        :key="ticket.id"
                        @click="openTicket(ticket.id)"
                        class="cursor-pointer"
                    >
                        <v-list-item-content>
                            <v-list-item-subtitle class="d-flex align-center justify-space-between">
                                <span>{{ formatDate(ticket.date) }}</span>
                                <v-chip x-small :color="ticket.trouble_status_color" dark>
                                    {{ ticket.trouble_status_text }}
                                </v-chip>
                            </v-list-item-subtitle>
                            <v-list-item-title class="d-flex align-center">
                                <span class="font-weight-bold mr-2">#{{ ticket.number }}</span>
                                <span class="text-truncate">{{ ticket.title }}</span>
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>
import { format } from 'date-fns'

export default {
    name: 'CompanyOpenTickets',

    props: {
        companyId: {
            type: Number,
            required: true
        },
        currentTicketId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            tickets: [],
            loading: false,
            expanded: true
        }
    },

    watch: {
        companyId: {
            immediate: true,
            handler(val) {
                if (val) this.loadTickets()
            }
        }
    },

    methods: {
        async loadTickets() {
            if (!this.companyId) return

            this.loading = true
            try {
                const response = await this.axios.get(`helpdesktroubles/company/${this.companyId}/open`, {
                    params: { exclude_id: this.currentTicketId }
                })
                this.tickets = response.data.data || []
            } catch (error) {
                console.error('Error loading company tickets:', error)
            } finally {
                this.loading = false
            }
        },

        openTicket(ticketId) {
            const route = this.$router.resolve({
                name: 'helpdesktroubles-show',
                params: { id: ticketId }
            })
            window.open(route.href, '_blank')
        },

        formatDate(date) {
            return date ? format(new Date(date), 'dd/MM/yyyy') : ''
        }
    }
}
</script>
